import { render, staticRenderFns } from "./YedieminInfo.vue?vue&type=template&id=509b648e"
import script from "./YedieminInfo.vue?vue&type=script&lang=ts"
export * from "./YedieminInfo.vue?vue&type=script&lang=ts"
import style0 from "./YedieminInfo.vue?vue&type=style&index=0&id=509b648e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports